import StopGo from '@/assets/images/stop-go-icon.svg?react';

import { StopGoIconStatus } from './types';

import style from './StopGoIcon.module.css';

export type StopGoIconProps = {
  status: StopGoIconStatus;
};

export const StopGoIcon = ({ status }: StopGoIconProps) => {
  return (
    <StopGo
      className={`${style['stop-go-icon']} ${status === StopGoIconStatus.GO ? 'stop-go-icon--stop' : 'stop-go-icon--go'}`}
    />
  );
};
